import { render, staticRenderFns } from "./SquareSquare.vue?vue&type=template&id=5a491845&"
import script from "./SquareSquare.vue?vue&type=script&lang=js&"
export * from "./SquareSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports